import React from "react";
import { useTranslation } from "react-i18next";
import "./AchievementCard.scss";

export default function AchievementCard({cardInfo, isDark}) {
  const { t } = useTranslation();
  
  function getTranslatedTitle(title) {
    switch(title) {
      case "Apple Certified iOS App Development with Swift":
        return t('achievements.apple.title');
      case "Hackathon Winner at AngelHack":
        return t('achievements.hackathon.title');
      case "Speaker at Mobile Dev Meetups & Conferences":
        return t('achievements.speaker.title');
      default:
        return title;
    }
  }
  
  function getTranslatedSubtitle(title) {
    switch(title) {
      case "Apple Certified iOS App Development with Swift":
        return t('achievements.apple.subtitle');
      case "Hackathon Winner at AngelHack":
        return t('achievements.hackathon.subtitle');
      case "Speaker at Mobile Dev Meetups & Conferences":
        return t('achievements.speaker.subtitle');
      default:
        return cardInfo.subtitle;
    }
  }
  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div className={isDark ? "dark-mode certificate-card" : "certificate-card"}>
      <div className="certificate-image-div">
        <img
          src={cardInfo.image}
          alt={cardInfo.imageAlt || "Card Thumbnail"}
          className="card-image"
        ></img>
      </div>
      <div className="certificate-detail-div">
        <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
          {getTranslatedTitle(cardInfo.title)}
        </h5>
        <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
          {getTranslatedSubtitle(cardInfo.title)}
        </p>
      </div>
      {cardInfo.footerLink && cardInfo.footerLink.length > 0 && (
        <div className="certificate-card-footer">
          {cardInfo.footerLink.map((v, i) => {
            return (
              <span
                key={i}
                className={
                  isDark ? "dark-mode certificate-tag" : "certificate-tag"
                }
                onClick={() => openUrlInNewTab(v.url, v.name)}
              >
                {v.name}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
